const fnrIconButtonProps = {
  legacy: {
    color: "fnLegacyGrey",
    hoverFocusColor: "fnLegacyGrey",
    backgroundColor: "divider",
    hoverFocusBackgroundColor: "divider",
    scaleIconOnly: true,
  },
};

export default fnrIconButtonProps;
